import { type ManagementDrillDownRow, type ManagementDrillLevel } from '../../../../models/peerToPeer/Management'
import { type ScopeOption } from '../ScopeFilter'

export const FILTER_LEVEL_OPTIONS: ScopeOption[] = [
  { value: 'State', label: 'State of Michigan' },
  { value: 'Rcn', label: 'RCN' },
  { value: 'Isd', label: 'ISD' },
  { value: 'District', label: 'District' }
]

/** State is the default label and lists RCN rows (like Rcn); Isd/District flatten to that level. */
export const ROW_NODE_LEVEL: Record<ManagementDrillLevel, ManagementDrillLevel> = {
  State: 'Rcn', Rcn: 'Rcn', Isd: 'Isd', District: 'District'
}

export const NEXT_LEVEL: Record<ManagementDrillLevel, ManagementDrillLevel | 'Buildings'> = {
  State: 'Rcn', Rcn: 'Isd', Isd: 'District', District: 'Buildings'
}

const LEVEL_PLURAL: Record<ManagementDrillLevel, string> = {
  State: 'State', Rcn: 'RCNs', Isd: 'ISDs', District: 'Districts'
}

/** Null at State: the whole country is already the selection, so there is nothing to pick. */
export const orgOptionsFor = (level: ManagementDrillLevel, rows: ManagementDrillDownRow[]): ScopeOption[] | null =>
  level === 'State'
    ? null
    : [
        { value: 'all', label: `All ${LEVEL_PLURAL[level]}` },
        ...rows.map(row => ({ value: String(row.organizationId), label: row.name }))
      ]
